(() => {
  const angular = window.angular;

  angular.module('app').config(ReportRouter);

  ReportRouter.$inject = ['$stateProvider'];

  function ReportRouter($stateProvider) {
    $stateProvider
      .state('member.project.edge-monitoring', {
        url: '/edge-monitoring',
        component: 'healthMonitoringStatusShow',
        redirectTo: 'member.project.edge-monitoring.uptime-realtime',
        authenticated: true,
        resolve: {
          module: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/d3.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
                window.assetsPath + `/css/editors-${style}.css`,
                window.assetsPath + '/js/vendors/editors/jsoneditor.min.js',
                window.assetsPath + '/js/app/health-monitoring.module.min.js',
                window.assetsPath + `/css/health-monitoring.style-${style}.css`,
              ]);
            },
          ],
          devices: [
            'Customer',
            '$rootScope',
            (Customer, $root) => {
              return Customer.prototype$__get__devices({
                id: $root.customerId,
                filter: {
                  fields: ['id', 'name', 'enabled'],
                },
              }).$promise;
            },
          ],
          adminUsers: ['AppUtils', (utils) => utils.Promise.resolve([])],
          users: [
            'Customer',
            '$rootScope',
            'AppUtils',
            function (Customer, $root, utils) {
              return Customer.managers({ id: $root.customerId }).$promise.catch((err) => {
                throw utils.getHTTPError(err, {
                  redirectTo: 'member.customer.show.home',
                  params: { customerId: $root.customerId },
                });
              });
            },
          ],
        },
        ncyBreadcrumb: {
          label: 'Edge Status',
        },
      })
      .state('member.project.edge-monitoring.events', {
        url: '/events',
        component: 'edgeEventManagement',
        authenticated: true,
        resolve: {},
        ncyBreadcrumb: {
          label: 'Event Management',
        },
      })
      .state('member.project.edge-monitoring.healthcheckEvents', {
        url: '/healthcheck-events',
        component: 'assetHealthcheckEventManagement',
        authenticated: true,
        resolve: {},
        ncyBreadcrumb: {
          label: 'Event Management',
        },
      })
      .state('member.project.edge-monitoring.vital-signs', {
        url: '/vital-signs',
        component: 'edgeMonitoringStatusVitalSignsTable',
        authenticated: true,
        resolve: {},
        ncyBreadcrumb: {
          label: 'Edge Status Table',
        },
      })

      .state('member.project.edge-monitoring.image-upload-monitoring', {
        url: '/image-upload',
        component: 'edgeMonitoringCameraBackground',
        authenticated: true,
        resolve: {},
        ncyBreadcrumb: {
          label: 'Image Upload monitoring',
        },
      })
      .state('member.project.edge-monitoring.uptime-realtime', {
        url: '/uptime-realtime',
        component: 'uptimeRealtime',
        authenticated: true,
        resolve: {},
        ncyBreadcrumb: {
          label: 'Realtime Status',
        },
      });
  }
})();
